var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-18.75 -18.75 224.98 224.98",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18.75,
    y: -18.75,
    width: 224.98,
    height: 224.98,
    rx: 112.49,
    fill: "#60c054",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 93.742,
    cy: 93.742,
    r: 35.898
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.484,88.742h-5.61c-2.498-41.953-36.179-75.635-78.132-78.132V5c0-2.761-2.238-5-5-5s-5,2.239-5,5v5.61 C46.789,13.108,13.107,46.789,10.61,88.742H5c-2.762,0-5,2.239-5,5s2.238,5,5,5h5.61c2.498,41.953,36.179,75.635,78.132,78.132 v5.61c0,2.761,2.238,5,5,5s5-2.239,5-5v-5.61c41.953-2.498,75.635-36.179,78.132-78.132h5.61c2.762,0,5-2.239,5-5 S185.246,88.742,182.484,88.742z M98.742,161.835v-8.621c0-2.761-2.238-5-5-5s-5,2.239-5,5v8.621 C55.065,159.384,28.1,132.42,25.649,98.742h8.622c2.762,0,5-2.239,5-5s-2.238-5-5-5h-8.622C28.1,55.065,55.065,28.1,88.742,25.649 v8.621c0,2.761,2.238,5,5,5s5-2.239,5-5v-8.621c33.677,2.451,60.642,29.416,63.093,63.093h-8.622c-2.762,0-5,2.239-5,5s2.238,5,5,5 h8.622C159.384,132.42,132.419,159.384,98.742,161.835z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location-marker.86def2587f1651d51cda0c865f9f0612.svg";
export { ForwardRef as ReactComponent };